import {DOM} from "../../../../../public/js/utils/DOM";

export namespace ControlsFormRatingPicker {

    class Config {
        public static readonly inputContainerClass = "RatingPicker";
        public static readonly valueDataName = "value";
        public static readonly filledClassName = "filled";
        public static readonly notFilledClassName = "notFilled";
        public static readonly selectedClassName = "selected";
        public static readonly inputClassName = "RatingPicker-input";
    }

    export class Control {

        /**
         * Main initialization function
         * @param container - form container element
         */
        public static initialize(container?: HTMLElement) : void {

            const inputs = DOM.Parser.getHtmlElements(Config.inputContainerClass, container, true) as HTMLCollectionOf<HTMLDivElement>;
            for (let i = 0; i < inputs.length; i++) {
                this.initializeElement(inputs[i]);
            }
        }

        /**
         * Initialize concrete element
         * @param element - input container main element
         * @private
         */
        private static initializeElement(element: HTMLDivElement) : void {

            const triggers = DOM.Parser.getHtmlElementsByQuery('i', element);
            const input = DOM.Parser.getHtmlElementByClass(Config.inputClassName, element) as HTMLInputElement;

            for (let i = 0; i < triggers.length; i++) {
                const trigger = triggers[i];
                trigger.addEventListener('click', () => { this.triggerClick(input, trigger, element, triggers); });
                trigger.addEventListener('mouseenter', () => { this.triggerEnter(trigger, element, triggers); });
                trigger.addEventListener('mouseleave', () => { this.triggerLeave(triggers); });
            }
        }

        /**
         * Trigger click action
         * @param input - input element
         * @param trigger - triggered element
         * @param element - container
         * @param triggers - list of star elements
         * @private
         */
        private static triggerClick(input: HTMLInputElement, trigger: HTMLElement, element: HTMLElement, triggers: NodeListOf<HTMLElement>) : void {

            const triggerValue = parseInt(DOM.Parser.getDataByNameFromElement(Config.valueDataName, trigger));
            input.value = triggerValue.toString();
            input.dispatchEvent(new Event('change'));

            for (let i = 0; i < triggers.length; i++) {
                triggers[i].classList.remove(Config.selectedClassName);
            }

            for (let x = 1; x <= triggerValue; x++) {
                DOM.Parser.getHtmlElementByQuery(`[data-value="${x}"]`, element).classList.add(Config.selectedClassName);
            }
        }

        /**
         * Trigger enter element action
         * @param trigger - triggered element
         * @param element - container
         * @param triggers - list of star elements
         * @private
         */
        private static triggerEnter(trigger: HTMLElement, element: HTMLElement, triggers: NodeListOf<HTMLElement>) : void {

            const triggerValue = parseInt(DOM.Parser.getDataByNameFromElement(Config.valueDataName, trigger));

            for (let i = 0; i < triggers.length; i++) {
                triggers[i].classList.remove(Config.filledClassName);
                triggers[i].classList.add(Config.notFilledClassName);
            }

            for (let x = 1; x <= triggerValue; x++) {
                const current = DOM.Parser.getHtmlElementByQuery(`[data-value="${x}"]`, element);
                current.classList.add(Config.filledClassName);
                current.classList.remove(Config.notFilledClassName);
            }
        }

        /**
         * Trigger leave element action
         * @param triggers - list of star elements
         * @private
         */
        private static triggerLeave(triggers: NodeListOf<HTMLElement>) : void {

            for (let i = 0; i < triggers.length; i++) {
                triggers[i].classList.remove(Config.filledClassName);
                triggers[i].classList.remove(Config.notFilledClassName);
            }
        }
    }
}